import { RouterProvider } from "react-router";
import { router } from "./router";

/**
 * App Component
 * Root component that provides router to entire application
 *
 * React Router v7 setup:
 * - RouterProvider wraps the entire app
 * - Routes configured in ./router.tsx
 * - Layouts and providers configured in route tree
 */
function App() {
  return <RouterProvider router={router} />;
}

export default App;
